import React from 'react'
import { Button } from '@mui/material'
import { Container } from './styles'
import type { PinForgottenButtonProps } from './types'

const PinForgottenButton: React.FC<PinForgottenButtonProps> = ({ onClick, t, isSmallScreen }) => (
  <Container isSmallScreen={isSmallScreen}>
    <Button size="small" variant="text" color="secondary" onClick={onClick} data-testid="forgotten-pin">
      {t('component.pinLogin.forgotten')}
    </Button>
  </Container>
)

export default PinForgottenButton
